import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap'
import '@/assets/style/bootstrap.scss'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
